import type { SVGProps } from "react";
import type { FC } from 'react';
import styled from 'styled-components';
import { iconSizeMap } from '../utils/size-map';
import type { IconSize, TokenSizeProps } from '../utils/type';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<TokenSizeProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M12.04 3.291a6.98 6.98 0 0 1 9.873.002c2.726 2.726 2.726 7.352 0 10.079l-.008.007L12 22.886 2.095 13.38l-.008-.007c-2.726-2.727-2.726-7.353 0-10.08a6.98 6.98 0 0 1 9.872 0l.04.04zm8.458 1.416a4.98 4.98 0 0 0-7.045 0l-.003.003L12 6.148 10.55 4.71l-.004-.003a4.98 4.98 0 0 0-7.044 0c-1.944 1.943-1.946 5.297-.007 7.244L12 20.114l8.505-8.163c1.939-1.947 1.936-5.3-.007-7.244" clipRule="evenodd" /></svg>;
const Wrapper = styled.span<{
  $size?: IconSize;
}>`
  width: ${({
  $size
}) => $size ? iconSizeMap[$size] : iconSizeMap.xs};
  height: ${({
  $size
}) => $size ? iconSizeMap[$size] : iconSizeMap.xs};
  display: inline-block;
  vertical-align: middle;
`;
const SvgHeart = ({
  $size,
  ...rest
}: TokenSizeProps) => <Wrapper $size={$size} className="mnd-icon"><SvgBase {...rest} /></Wrapper>;
export default SvgHeart;